import React from "react";
import { useTranslation } from 'react-i18next';

// Client routes
import HomePage from "../../home/home-page";
import InvoicesPage from "../../invoices/invoices-page";
import DeliveryNotesPage from "../../delivery-notes/delivery-notes-page";
import StocksPage from "../../stocks/stocks-page";
import ServicesPage from "../../services/services-page";
import TechnicalSheetsPage from "../../technical-sheets/technical-sheets-page";
import DocumentationPage from "../../documentation/documentation-page";
import TransportationPage from "../../transportation/transportation-page";

// Admin Routes
import AdminHomePage from "../../admin-home/admin-home-page";
import ClientsPage from "../../clients/clients-page";
import UsersPage from "../../users/users-page";
import AuditPage from "../../audit/audit-page";
import ExecutionPage from "../../executions/execution-page";
import AdminDocumentationPage from "../../documentation/admin-documentation-page";

const useAppRoutes = (props) => {
    const {t} = useTranslation("header");

    return [{
        text: t("navigation.home"),
        to: "/home",
        isAdminRoute: false,
        component: () => <HomePage/>
    }, {
        text: t("navigation.invoices"),
        to: "/invoices",
        isAdminRoute: false,
        component: () => <InvoicesPage/>
    }, {
        text: t("navigation.delivery-notes"),
        to: "/delivery-notes",
        isAdminRoute: false,
        component: () => <DeliveryNotesPage/>
    }, {
        text: t("navigation.stocks"),
        to: "/stocks",
        isAdminRoute: false,
        component: () => <StocksPage/>
    }, {
        text: t("navigation.services"),
        to: "/services",
        isAdminRoute: false,
        component: () => <ServicesPage/>
    }, {
        text: t("navigation.technical-sheets"),
        to: "/technical-sheets",
        isAdminRoute: false,
        component: () => <TechnicalSheetsPage/>
    },
    {
        text: t("navigation.documentation"),
        to: "/documentation",
        isAdminRoute: false,
        component: () => <DocumentationPage/>
    },
    {
        text: t("navigation.transportation"),
        to: "/transportation",
        isAdminRoute: false,
        component: () => <TransportationPage/>
    }, {
        text: t("navigation.admin-home"),
        to: "/admin-home",
        isAdminRoute: true,
        component: () => <AdminHomePage/>
    }, {
        text: t("navigation.clients"),
        to: "/clients",
        isAdminRoute: true,
        component: () => <ClientsPage/>
    }, {
        text: t("navigation.users"),
        to: "/users",
        isAdminRoute: true,
        component: () => <UsersPage/>
    }, {
        text: t("navigation.audit"),
        to: "/audit",
        isAdminRoute: true,
        component: () => <AuditPage/>
    },
    {
        text: t("navigation.executions"),
        to: "/executions",
        isAdminRoute: true,
        component: () => <ExecutionPage/>
    },
    {
        text: t("navigation.documentation"),
        to: "/admin-documentation",
        isAdminRoute: true,
        component: () => <AdminDocumentationPage/>
    }];
};

export default useAppRoutes;